import add1 from "./particles/Add1.svg";
import add2 from "./particles/Add2.svg";
import add3 from "./particles/Add3.svg";

import ribbon1 from "./particles/ribbon1.svg";
import ribbon2 from "./particles/ribbon2.svg";
import ribbon3 from "./particles/ribbon3.svg";

import square1 from "./particles/square1.svg";
import square2 from "./particles/square2.svg";
import square3 from "./particles/square3.svg";

import triangle1 from "./particles/triangle1.svg";
import triangle2 from "./particles/triangle2.svg";
import triangle3 from "./particles/triangle3.svg";

export default {
  "absorbers": {
    "color": {
      "value": "#000000"
    },
    "opacity": 1,
    "size": {
      "density": 0,
      "random": {
        "enable": false,
        "minimumValue": 0
      },
      "value": 0,
      "limit": 0
    },
    "position": {
      "x": 0,
      "y": 0
    }
  },
  "background": {},
  "backgroundMask": {
    "cover": {
      "color": {
        "value": "#fff"
      },
      "opacity": 1
    },
    "enable": false
  },
  "detectRetina": true,
  "emitters": {
    "direction": "bottom",
    "life": {},
    "rate": {
      "quantity": 1,
      "delay": 0.1
    },
    "size": {
      "mode": "percent",
      "height": 0,
      "width": 100
    },
    "position": {
      "x": 50,
      "y": 0
    }
  },
  "fpsLimit": 60,
  "interactivity": {},
  "particles": {
    "collisions": {
      "enable": false,
      "mode": "bounce"
    },
    "color": {
      "value": "#ffffff"
    },
    "lineLinked": {
      "blink": false,
      "color": {
        "value": "#000"
      },
      "consent": false,
      "distance": 150,
      "enable": false,
      "opacity": 0.4,
      "shadow": {
        "blur": 5,
        "color": {
          "value": "lime"
        },
        "enable": false
      },
      "width": 1
    },
    "move": {
      "attract": {
        "enable": false,
        "rotate": {
          "x": 600,
          "y": 1200
        }
      },
      "direction": "none",
      "enable": true,
      "outMode": "destroy",
      "random": false,
      "speed": 2,
      "straight": false,
      "trail": {
        "enable": false,
        "length": 10,
        "fillColor": {
          "value": "#000000"
        }
      }
    },
    "number": {
      "density": {
        "enable": true,
        "area": 800
      },
      "limit": 0,
      "value": 0
    },
    "opacity": {
      "animation": {
        "enable": false,
        "minimumValue": 0.5,
        "speed": 1,
        "sync": false
      },
      "random": {
        "enable": true,
        "minimumValue": 1
      },
      "value": 1
    },
    "rotate": {
      "animation": {
        "enable": true,
        "speed": 20,
        "sync": false
      },
      "direction": "random",
      "random": true,
      "value": 0
    },
    "shadow": {
      "blur": 1,
      "color": {
        "value": "#e4005a"
      },
      "enable": false,
      "offset": {
        "x": 1,
        "y": 1
      }
    },
    "shape": {
      "options": {
        "character": {
          "fill": false,
          "close": true,
          "font": "Verdana",
          "style": "",
          "value": "*",
          "weight": "400"
        },
        "char": {
          "fill": false,
          "close": true,
          "font": "Verdana",
          "style": "",
          "value": "*",
          "weight": "400"
        },
        "polygon": {
          "fill": true,
          "close": true,
          "sides": 5
        },
        "star": {
          "fill": true,
          "close": true,
          "sides": 5
        }
      },
      "image": [
        {
          "fill": true,
          "close": true,
          "height": 100,
          "replaceColor": false,
          "src": add1,
          "width": 100
        },
        {
          "fill": true,
          "close": true,
          "height": 100,
          "replaceColor": false,
          "src": add2,
          "width": 100
        },
        {
          "fill": true,
          "close": true,
          "height": 100,
          "replaceColor": false,
          "src": add3,
          "width": 100
        },
        {
          "fill": true,
          "close": true,
          "height": 100,
          "replaceColor": false,
          "src": ribbon1,
          "width": 100
        },
        {
          "fill": true,
          "close": true,
          "height": 100,
          "replaceColor": false,
          "src": ribbon2,
          "width": 100
        },
        {
          "fill": true,
          "close": true,
          "height": 100,
          "replaceColor": false,
          "src": ribbon3,
          "width": 100
        },
        {
          "fill": true,
          "close": true,
          "height": 100,
          "replaceColor": false,
          "src": square1,
          "width": 100
        },
        {
          "fill": true,
          "close": true,
          "height": 100,
          "replaceColor": false,
          "src": square2,
          "width": 100
        },
        {
          "fill": true,
          "close": true,
          "height": 100,
          "replaceColor": false,
          "src": square3,
          "width": 100
        },
        {
          "fill": true,
          "close": true,
          "height": 100,
          "replaceColor": false,
          "src": triangle1,
          "width": 100
        },
        {
          "fill": true,
          "close": true,
          "height": 100,
          "replaceColor": false,
          "src": triangle2,
          "width": 100
        },
        {
          "fill": true,
          "close": true,
          "height": 100,
          "replaceColor": false,
          "src": triangle3,
          "width": 100
        }
      ],
      "type": "image"
    },
    "size": {
      "animation": {
        "enable": false,
        "minimumValue": 0.1,
        "speed": 40,
        "sync": false
      },
      "random": {
        "enable": false,
        "minimumValue": 1
      },
      "value": 10
    },
    "stroke": {
      "color": {
        "value": "#000000"
      },
      "width": 0,
      "opacity": 1
    },
    "twinkle": {
      "lines": {
        "enable": false,
        "frequency": 0.05,
        "opacity": 1
      },
      "particles": {
        "enable": false,
        "frequency": 0.05,
        "opacity": 1
      }
    }
  },
  "pauseOnBlur": true,
  "polygon": {
    "draw": {
      "enable": false,
      "stroke": {
        "color": {
          "value": "#fff"
        },
        "width": 0.5,
        "opacity": 1
      }
    },
    "enable": true,
    "inline": {
      "arrangement": "one-per-point"
    },
    "move": {
      "radius": 10,
      "type": "path"
    },
    "scale": 1,
    "type": "none",
    "url": ""
  }
}